module.exports = __webpack_public_path__ + "img/wlLogo.9ce590ef.png";